@for (field of field.fieldGroup; track field; let i = $index) {
  <div>
    <div class="dynamic-param-section">
      <formly-field [field]="field"></formly-field>
    </div>
  </div>
}
